import { FormSelectConfig } from '/@/modules/core/form/models/FormSelectConfig';
import Lang from '/@/modules/core/app/services/Lang';
import { AnthropicModel } from '@/modules/ai/constants/AnthropicModel';
import { GeminiModel } from '@/modules/ai/constants/GeminiModel';
import { OpenAIModel } from '@/modules/ai/constants/OpenAIModel';

export class AiModelSelectConfig extends FormSelectConfig {
  constructor(config = {}) {
    super({
      ...config,
      trackBy: 'key',
      label: 'value',
      groupValues: 'data',
      groupLabel: 'group',
      groupSelect: false,
      placeholder: Lang.t('ai.select-a-model')
    });
  }

  async getOptions(params = {}) {
    return [
      {
        group: 'Anthropic',
        data: AnthropicModel.getValues()
      },
      {
        group: 'Google',
        data: GeminiModel.getValues()
      },
      {
        group: 'OpenAI',
        data: OpenAIModel.getValues()
      }
    ];
  }
}
